var Themes = /* @__PURE__ */ ((Themes2) => {
  Themes2["Light"] = "light";
  return Themes2;
})(Themes || {});
const CURRENT_VERSION = "v1";
export {
  CURRENT_VERSION,
  Themes
};
